module.exports = __webpack_public_path__ + "media/images/app/products/shipping-bag-8e2006a6dbf4518c523819603af0f3fa.svg";